import { clsx, type ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

/**
 * tailwind-merge ne connaît pas nos échelles typographiques maison.
 * Sans cette extension, il prend `text-h2` pour une couleur de texte et le
 * supprime au profit de `text-ink-900` : le titre perd sa taille.
 *
 * Toute nouvelle taille déclarée dans globals.css (@theme --text-*) doit être
 * ajoutée ici.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: ['display', 'h1', 'h2', 'h3', 'lead', 'eyebrow'] }],
    },
  },
})

/** Fusionne des classes Tailwind sans conflit. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
